// PENSILINE Flow Rules — Linea Mini 3, Linea Maxi 3, Sfera-N

export const PENSILINE_TYPES = [
  {
    id: 'linea-mini',
    name: 'Linea Mini 3',
    prefix: 'LM',
    description: 'Pensilina a sbalzo, sbalzo max 120 cm',
    maxOverhang: 1200,
    glassOptions: [{ code: '16', label: '8+8 SG', value: '8+8' }],
  },
  {
    id: 'linea-maxi',
    name: 'Linea Maxi 3',
    prefix: 'LX',
    description: 'Pensilina a sbalzo, sbalzo max 160 cm',
    maxOverhang: 1600,
    glassOptions: [
      { code: '20', label: '10+10 SG', value: '10+10' },
      { code: '24', label: '12+12 SG', value: '12+12' },
    ],
  },
  {
    id: 'sfera-n',
    name: 'Sfera-N',
    prefix: 'PEN1',
    description: 'Pensilina con tiranti in acciaio inox AISI 316',
    maxOverhang: 1500,
  },
];

export const CARTER_OPTIONS = [
  { code: 'K', label: 'Carter a Scatto', capCode: '6' },
  { code: 'KL', label: 'Carter per LED', capCode: '7' },
];

export const LENGTH_OPTIONS = [
  { code: '150', label: '1500 mm', mm: 1500, meters: 1.5 },
  { code: '200', label: '2000 mm', mm: 2000, meters: 2 },
  { code: '300', label: '3000 mm', mm: 3000, meters: 3 },
  { code: '400', label: '4000 mm', mm: 4000, meters: 4 },
  { code: '600', label: '6000 mm', mm: 6000, meters: 6 },
  { code: 'T', label: 'Tagliato a misura', mm: null, meters: null },
];

export const FIXING_OPTIONS = [
  { code: '', label: 'Senza fissaggi', suffix: '' },
  { code: 'Z', label: 'Fissaggi Zincati', suffix: 'Z' },
  { code: 'X', label: 'Fissaggi Inox', suffix: 'X' },
];

export const FINISH_OPTIONS = [
  { code: 'G', label: 'Grezzo', group: 'standard', color: '#E0E0E0' },
  { code: 'A', label: 'Argento anodizzato satinato', group: 'standard', color: '#C0C0C0' },
  { code: 'B', label: 'Bianco RAL 9010 opaco', group: 'standard', color: '#FFFFFF' },
  { code: 'N', label: 'Nero RAL 9005 opaco', group: 'standard', color: '#000000' },
  { code: 'V1', label: 'Verniciatura speciale (> 48 mt)', group: 'special', needsRal: true, color: '#D3D3D3' },
  { code: 'V2', label: 'Verniciatura speciale (13-48 mt)', group: 'special', needsRal: true, color: '#D3D3D3' },
  { code: 'V3', label: 'Verniciatura speciale (1-12 mt)', group: 'special', needsRal: true, color: '#D3D3D3' },
];

export function composePensilineCode(type, carter, length, fixing, glass, finish) {
  const prefix = type === 'linea-mini' ? 'LM' : 'LX';
  const lengthCode = length === 'T' ? 'T' : length;
  return `${prefix}-${carter}${lengthCode}-${fixing}${glass}${finish}`;
}

// Tappi code: {LM|LX}-{6|7}{finish}{DX|SX}
export function getTappiCodes(type, carterCode, finishCode) {
  const prefix = type === 'linea-mini' ? 'LM' : 'LX';
  const capNum = carterCode === 'KL' ? '7' : '6';
  const tapFinish = finishCode === 'V3' ? 'V2' : finishCode;
  return {
    dx: `${prefix}-${capNum}${tapFinish}DX`,
    sx: `${prefix}-${capNum}${tapFinish}SX`,
  };
}

// Tappi pricing by type and carter and finish
const TAPPI_PRICES = {
  'LM-6': { G: 9.80, A: 12.20, B: 13.10, N: 13.10, V1: 13.80, V2: 19.30 },
  'LM-7': { G: 10.50, A: 13.30, B: 14.40, N: 14.40, V1: 15.10, V2: 21.20 },
  'LX-6': { G: 10.80, A: 13.40, B: 14.40, N: 14.40, V1: 15.20, V2: 21.30 },
  'LX-7': { G: 11.60, A: 14.60, B: 15.80, N: 15.80, V1: 16.60, V2: 23.20 },
};

export function getTappiPrice(type, carterCode, finishCode) {
  const prefix = type === 'linea-mini' ? 'LM' : 'LX';
  const capNum = carterCode === 'KL' ? '7' : '6';
  const key = `${prefix}-${capNum}`;
  const finishKey = finishCode.startsWith('V') ? (finishCode === 'V3' ? 'V2' : finishCode) : finishCode;
  return TAPPI_PRICES[key]?.[finishKey] || 0;
}

// Kit Antisfilamento
export const ANTISFILAMENTO = {
  'linea-mini': {
    code: 'LM-AS',
    price: 8.00,
    rules: [
      { maxWidth: 3000, qty: 2 },
      { maxWidth: 4000, qty: 3 },
    ],
  },
  'linea-maxi': {
    code: 'LX-AS',
    price: 9.00,
    rules: [
      { maxWidth: 1500, qty: 2 },
      { maxWidth: 2500, qty: 3 },
      { maxWidth: 3000, qty: 4 },
      { maxWidth: 4000, qty: 5 },
    ],
  },
};

export function getAntisfilamentoQty(type, glassWidthMm) {
  const config = ANTISFILAMENTO[type];
  if (!config) return 0;
  const width = parseInt(glassWidthMm, 10) || 0;
  for (const rule of config.rules) {
    if (width <= rule.maxWidth) return rule.qty;
  }
  return config.rules[config.rules.length - 1]?.qty || 0;
}

// Sfera-N catalog
export const SFERA_N_KITS = [
  { code: 'PEN1-K160/120', description: 'Kit attacco singolo 160x120 cm', price: 1038.00, glass: 'min 6+6, max 10+10 PVB' },
  { code: 'PEN1-K200/120', description: 'Kit attacco singolo 200x120 cm', price: 1041.00, glass: 'min 6+6, max 10+10 PVB' },
  { code: 'PEN1-K160/150', description: 'Kit attacco singolo 160x150 cm', price: 1054.00, glass: 'min 6+6, max 10+10 PVB' },
  { code: 'PEN1-K200/150', description: 'Kit attacco singolo 200x150 cm', price: 1057.00, glass: 'min 6+6, max 10+10 PVB' },
  { code: 'PEN1A-K120', description: 'Kit attacco doppio 160/200x120 cm', price: 1196.00, glass: 'min 6+6, max 10+10 PVB' },
  { code: 'PEN1A-K150', description: 'Kit attacco doppio 160/200x150 cm', price: 1212.00, glass: 'min 6+6, max 10+10 PVB' },
];

export const SFERA_N_COMPONENTS = [
  // Attacco superiore angolare
  { code: 'FP20-H1', description: 'Attacco superiore angolare Lucido, vetro 1200mm', price: 463.00 },
  { code: 'FP20-H1-ST', description: 'Attacco superiore angolare Satinato, vetro 1200mm', price: 475.00 },
  { code: 'FP20-H2', description: 'Attacco superiore angolare Lucido, vetro 1500mm', price: 496.00 },
  { code: 'FP20-H2-ST', description: 'Attacco superiore angolare Satinato, vetro 1500mm', price: 508.00 },
  { code: 'FP20-H3', description: 'Attacco superiore angolare Lucido, su misura (fino a 2000mm)', price: 551.00, needsNote: true },
  { code: 'FP20-H3-ST', description: 'Attacco superiore angolare Satinato, su misura (fino a 2000mm)', price: 563.00, needsNote: true },
  // Rotula per vetro
  { code: 'FP22', description: 'Rotula per fissaggio vetro Lucido', price: 114.00 },
  { code: 'FP22-ST', description: 'Rotula per fissaggio vetro Satinato', price: 126.00 },
  // Fissaggio a parete
  { code: 'FP24', description: 'Fissaggio a parete snodata Lucido', price: 216.00 },
  { code: 'FP24-ST', description: 'Fissaggio a parete snodata Satinato', price: 228.00 },
  // Attacco superiore dritto
  { code: 'FP20A-H1', description: 'Attacco superiore dritto Lucido, vetro 1200mm', price: 309.00 },
  { code: 'FP20A-H1-ST', description: 'Attacco superiore dritto Satinato, vetro 1200mm', price: 321.00 },
  { code: 'FP20A-H2', description: 'Attacco superiore dritto Lucido, vetro 1500mm', price: 325.00 },
  { code: 'FP20A-H2-ST', description: 'Attacco superiore dritto Satinato, vetro 1500mm', price: 337.00 },
  { code: 'FP20A-H3', description: 'Attacco superiore dritto Lucido, su misura (fino a 2000mm)', price: 350.00, needsNote: true },
  { code: 'FP20A-H3-ST', description: 'Attacco superiore dritto Satinato, su misura (fino a 2000mm)', price: 362.00, needsNote: true },
  // Rotula snodata
  { code: 'FP01', description: 'Rotula snodata Lucido', price: 173.00 },
  { code: 'FP01-ST', description: 'Rotula snodata Satinato', price: 185.00 },
  // Accessori con piastra girevole
  { code: 'FP09A-1', description: 'Piastra girevole Satinato, vetro 1200mm', price: 296.00 },
  { code: 'FP09A-2', description: 'Piastra girevole Satinato, vetro 1500mm', price: 316.00 },
  { code: 'FP09A-3', description: 'Piastra girevole Satinato, su misura (fino a 2000mm)', price: 338.00, needsNote: true },
  { code: 'FP10', description: 'Piastra girevole per facciate in alluminio Satinato', price: 270.00 },
];

// Accessori pensiline (ricambi/accessori vari)
export const PENSILINE_ACCESSORIES = [
  { code: 'FL10B', description: 'Profilo plastico chiusura porta LED (3mt)', price: 7.10, unit: 'ML' },
  { code: 'FL10B-T', description: 'Profilo plastico porta LED tagliato a misura', price: 9.60, unit: 'ML' },
  { code: 'KIT-CD', description: 'Set chiavi dinamometriche in custodia', price: 179.00, unit: 'PZ' },
  { code: 'KIT-CDM8', description: 'Chiave dinamometrica singola misura 13', price: 19.00, unit: 'PZ' },
  { code: 'KIT-CDM10', description: 'Chiave dinamometrica singola misura 15', price: 19.00, unit: 'PZ' },
  // Astine di fissaggio
  { code: 'M09-12', description: 'Astina zincata M10X130 con dado e rondella', price: 3.20, unit: 'PZ', validFor: ['linea-mini'] },
  { code: 'FIS10130X', description: 'Astina inox M10X130', price: 5.20, unit: 'PZ', validFor: ['linea-mini'] },
  { code: 'M13-AC-08', description: 'Astina zincata M12X140 con dado e rondella', price: 4.00, unit: 'PZ', validFor: ['linea-maxi'] },
  { code: 'FIS12140X', description: 'Astina inox M12X140', price: 6.10, unit: 'PZ', validFor: ['linea-maxi'] },
  // Rondelle
  { code: 'N6-AC-FISM10', description: 'Rondella per fissaggio M10', price: 0.80, unit: 'PZ', validFor: ['linea-mini'] },
  { code: 'N6-AC-FISM12', description: 'Rondella per fissaggio M12', price: 0.80, unit: 'PZ', validFor: ['linea-maxi'] },
  // Registri
  { code: 'LX-RM', description: 'Registro Linea Mini', price: 10.50, unit: 'PZ', validFor: ['linea-mini'] },
  { code: 'LX-RG', description: 'Registro Linea Maxi per vetro 12+12', price: 11.90, unit: 'PZ', validFor: ['linea-maxi'] },
  { code: 'LX-RG4', description: 'Registro Linea Maxi per vetro 10+10', price: 13.10, unit: 'PZ', validFor: ['linea-maxi'] },
  { code: 'N6-REG1', description: 'Tassello per registro da 4mm', price: 0.40, unit: 'PZ', validFor: ['linea-maxi'] },
  // Guarnizioni
  { code: 'N6-G1', description: 'Guarnizione 13x9mm da infilare', price: 2.00, unit: 'ML' },
  { code: 'N6-G2', description: 'Guarnizione 13x3mm da infilare', price: 2.40, unit: 'ML', validFor: ['linea-maxi'] },
  { code: 'LX-G1', description: 'Guarnizione 11x6mm da infilare', price: 2.20, unit: 'ML' },
];

export function getFinishTier(totalMeters) {
  if (totalMeters > 48) return 'V1';
  if (totalMeters >= 13) return 'V2';
  return 'V3';
}
